/**
 * Routes
 */

const CoreRoutes = [
  {
    name: "Base",
    path: "/",
    redirect: "/home",
    meta: {
      requiresAuth: true,
    },
  },
];

const CoreSettingsRoutes = [];

const CoreBaseDataRoutes = [];

export { CoreRoutes, CoreSettingsRoutes, CoreBaseDataRoutes };
